import React, { Component } from "react";
import ValidBrowser from "../Utils/ValidBrowser";
import { testValidBrowser } from "../Utils/helpers";
import NavButton from "../Components/Button/Nav.button.jsx";
import speekerLogo from '../img/logo_speeker.png';
// import Footer from "../Components/Footer";

const style = {
  info: {
    color: "red",
    display: "bloc",
    fontSize: ".7rem"
  },
  link: {
    color: "blue",
    textDecoration: "underline"
  },
  tuto: {
    width: "50%",
    margin: "auto",
    textAlign: "center",
    lineHeight: "2.5rem"
  },
  buttons: {
    marginTop: "20px",
    display: "inline-block"
  },
  beta: {
    color: "red",
    fontSize: "12px",
    marginTop: "50px"
  },
  bold: {
    fontWeight: "bold",
  }
};

export default class Home extends Component {
  render() {
    return (
      <div style={{marginTop: "100px"}}>
        <h1>SPEEKER : La 1ère Plateforme d’entraînement au Pitch</h1>

        <img
          src={speekerLogo}
          alt="logo Speeker"
          width="400"
        />

        <div>
          <div style={style.buttons}>
            <ValidBrowser
              test={testValidBrowser}
              valid={
                <NavButton
                  label="Enregistrer"
                  href="/record"
                  disabled={false}
                />
              }
              error={
                <div>
                  <NavButton
                    label="Enregistrer"
                    href="/record"
                    disabled={true}
                  />
                </div>
              }
            />
          </div>
          <NavButton label="Evaluer" href="/pitchs" disabled={false} />
        </div>

        <div>
          {/* <p>
            Envie de t’entrainer à parler de ton projet, de ton parcours ou d’une idée 
            absolument folle qui va révolutionner le monde ? 
          </p> */}
          <p style={style.tuto}>
            Envie de t’entrainer à parler de ton projet, de ton parcours ou d’une idée 
            absolument folle qui va révolutionner le monde ?<br />
            1. <span style={style.bold}>Enregistrer:</span> Pitch en 90 secondes maximum et partage-le pour recevoir des évaluations !<br />
            2. <span style={style.bold}>Evaluer:</span> Aide les autres à progresser en évaluant leur pitch.
          </p>
        </div>

        <ValidBrowser
          test={testValidBrowser}
          valid={<div />}
          error={
            <p style={style.beta}>
              [Version beta] Enregistrement uniquement disponible sur Pc / Mac +{" "}
              <a
                href="https://www.google.fr/chrome/?brand=CHBD&gclid=Cj0KCQjwsMDeBRDMARIsAKrOP7FxXxr_CEEcmiBH9uySPVqwP083nVZL6BwJovIDsJgawhl22VueJ94aApQ1EALw_wcB&gclsrc=aw.ds"
                style={style.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                Chrome,
              </a>{" "}
              <a
                href="https://www.mozilla.org/en-US/firefox/new/?utm_source=google&utm_medium=cpc&utm_campaign=Brand-FR-EN-GGL-Exact&utm_term=telecharger%20firefox&utm_content=A144_A203_A006160&&gclid=Cj0KCQjwsMDeBRDMARIsAKrOP7Fw0dI4xkF_7zNSF-wlWuzv-rUrQqqASMBeEW_OGChl67VK87yCRzQaAsX7EALw_wcB&gclsrc=aw.ds"
                style={style.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                Firefox
              </a>{" "}
              ou{" "}
              <a
                href="https://www.opera.com/fr"
                style={style.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                Opera.
              </a>
            </p>
          }
        />

        {/* <Footer /> */}
      </div>
    );
  }
}
